import { render, staticRenderFns } from "./FileGalleryItem.vue?vue&type=template&id=07cd9e38"
import script from "./FileGalleryItem.vue?vue&type=script&lang=js"
export * from "./FileGalleryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports